export default "__VITE_ASSET__v6_RWdtk__"